import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import './MenuTrigger.scss';

interface MenuTriggerProps {
  icon: IconProp;
  label: string;
  isOpen: boolean;
  onClick: () => void;
  className?: string;
}

const MenuTrigger: React.FC<MenuTriggerProps> = ({
  icon,
  label,
  isOpen,
  onClick,
  className = '',
}) => (
  <button
    className={`menu-trigger ${className}`}
    onClick={onClick}
    aria-expanded={isOpen}
    type="button"
  >
    <FontAwesomeIcon icon={icon} className="menu-trigger-icon" />
    <span className="menu-trigger-label">{label}</span>
    <FontAwesomeIcon
      icon={faChevronDown}
      className={`menu-trigger-chevron ${isOpen ? 'open' : ''}`}
    />
  </button>
);

export default MenuTrigger;
